import {SalesOfficeData} from '../../declarations/types'
import {
  PersistedRequestForQuoteFormValues,
  RequestForQuoteFormValues,
  RequestForQuoteMaterial,
  RequestForQuoteOffice,
  RequestForQuotePayload
} from '../../RequestForQuoteFormValues'

export const sanitizeRfqOffice = (office: SalesOfficeData): SalesOfficeData => ({
  country: office.country,
  region: office.region,
  plant: office.plant ?? '',
  nationalFlg: office.nationalFlg,
  businessLine: office.businessLine,
  salesOrganization: office.salesOrganization,
  companyName: office.companyName,
  productCategoryCode: office.productCategoryCode
})

const mapMaterials = (materials: RequestForQuoteMaterial[]) =>
  materials.map((material) => ({
    id: material.id,
    name: material.name,
    quantity: {
      amount: material.quantity.amount,
      unitOfMeasure: material.quantity.unitOfMeasure
    },
    isWithoutAdditives: material.isWithoutAdditives
  }))

export const toPersistedRequestForQuote = (
  values: PersistedRequestForQuoteFormValues
): PersistedRequestForQuoteFormValues => ({
  customerName: values.customerName,
  customerNumber: values.customerNumber,
  phoneNumber: values.phoneNumber,
  projectType: values.projectType,
  businessLine: values.businessLine,
  materials: mapMaterials(values.materials ?? []),
  services: values.services,
  selectedCountry: values.selectedCountry,
  region: values.region,
  plant: values.plant,
  selectedRegion: values.selectedRegion ? sanitizeRfqOffice(values.selectedRegion) : undefined,
  selectedSupplier: values.selectedSupplier,
  supplier: values.supplier
})

export const toRequestForQuotePayload = (
  values: RequestForQuoteFormValues,
  selectedRegion: RequestForQuoteOffice,
  selectedPlant?: RequestForQuoteOffice
): RequestForQuotePayload => {
  const office = selectedPlant ?? selectedRegion
  return {
    customerName: values.customerName,
    customerNumber: values.customerNumber,
    phoneNumber: values.phoneNumber,
    projectDetails: {
      projectStartDate: values.projectDetails.projectStartDate,
      projectEndDate: values.projectDetails.projectEndDate,
      projectStatus: values.projectDetails.projectStatus,
      projectDestination: {
        name: values.projectDetails.projectDestination.name,
        street: values.projectDetails.projectDestination.street,
        zip: values.projectDetails.projectDestination.zip,
        city: values.projectDetails.projectDestination.city,
        mapCoordinates: values.projectDetails.projectDestination.mapCoordinates
      }
    },
    projectType: values.projectType,
    businessLine: values.businessLine,
    materials: mapMaterials(values.materials),
    services: values.services,
    poNumber: values.poNumber,
    comment: values.comment,
    selectedCountry: values.selectedCountry,
    plant: office.plant,
    region: office.region,
    salesOrganization: office.salesOrganization,
    productCategoryCode: office.productCategoryCode,
    companyName: office.companyName,
    attachment: values.attachment
      ? {
          fileName: values.attachment.fileName,
          fileContent: values.attachment.fileContent,
          fileHash: values.attachment.fileHash,
          fileExtension: values.attachment.fileExtension
        }
      : undefined,
    isSmartRockEnabled: values.isSmartRockEnabled,
    supplier: values.supplier
  }
}
